<template>
  <div>
    <head-individ />
    <another-site />
    <div class="container">
      <div class="buisnessIndivid">
        <div class="buisnessIndivid-left">
          <p
            class="buisnessIndivid-left__title"
            v-html="buisnessInd[0].title"
          />
          <p
            class="buisnessIndivid-left__sub"
            v-html="buisnessInd[0].desc"
          />
          <div class="buisnessIndivid-left__type">
            <div
              v-for="b in buisnessInd[0].sub_type"
              :key="b"
              class="buisnessIndivid-left__type_par"
            >
              <p
                class="title"
                v-html="b.title"
              />
              <p
                class="sub"
                v-html="b.desc"
              />
            </div>
          </div>
          <div class="buisnessIndivid-left__btn white_hover__btn">
            <a :href="$i18n.locale === 'en' ? 'https://cic.kz/?scroll=bottom' : buisnessInd[0].link">
              <button>
                {{ $i18n.locale === 'en' ? 'MORE INFORMATION' : $t('buttons.moreBtn1')+" kupipolis.kz" }}
              </button>
            </a>
          </div>
        </div>
        <div class="buisnessIndivid-left__btn__mobile white_hover__btn">
          <a :href="$i18n.locale === 'en' ? 'https://cic.kz/?scroll=bottom' : buisnessInd[0].link">
            <button>
              {{ $i18n.locale === 'en' ? 'MORE INFORMATION' : $t('buttons.moreBtn1')+" kupipolis.kz" }}
            </button>
          </a>
        </div>
        <div class="buisnessIndivid-right">
          <img
            :src="cdn + buisnessInd[0].icon"
            alt=""
          >
        </div>
      </div>
    </div>
    <service-main />
  </div>
</template>

<script>
import HeadIndivid from "../components/HeadIndivid.vue";
import anotherSite from "../components/anotherSite.vue";
import ServiceMain from "../components/ServiceMain.vue";
import axios from "axios";
import { mapState } from "vuex";
export default {
  components: { HeadIndivid, anotherSite, ServiceMain },
  data() {
    return {
      buisnessInd: [],
      errors: [],
    };
  },
  computed: {
    ...mapState(["cdn"]),
  },
  created() {
    axios
      .get("V1/individual-insurance-business")
      .then((response) => {
        this.buisnessInd = response.data.data;
      })
      .catch((e) => {
        this.errors.push(e);
      });
  },
};
</script>

<style lang="scss" scoped>
@mixin fontStyle($family, $style, $weight, $size, $lheight, $color) {
  font-family: $family;
  font-style: normal;
  font-weight: $weight;
  font-size: $size;
  line-height: $lheight;
  color: $color;
}
@mixin mobile {
  @media (min-width: 320px) and (max-width: 425px) {
    @content;
  }
}
@mixin tablet {
  @media (min-width: 425px) and (max-width: 767px) {
    @content;
  }
}
@mixin tablet-1024 {
  @media (min-width: 767px) and (max-width: 1023px) {
    @content;
  }
}
@mixin desktop {
  @media (min-width: 1023px) and (max-width: 1440px) {
    @content;
  }
}
@mixin desktop-max {
  @media (min-width: 1620px) and (max-width: 2560px) {
    @content;
  }
}
.buisnessIndivid {
  background: #efefef;
  border-radius: 15px;
  display: flex;
  justify-content: space-between;
  margin-top: 85px;
  margin-bottom: 70px;
  padding: 65px 70px;
  &-left {
    &__title {
      @include fontStyle(Roboto, normal, 500, 36px, 43px, #373737);
      letter-spacing: 0.03em;
      text-transform: uppercase;
    }
    &__sub {
      @include fontStyle(Roboto, normal, 300, 18px, 22px, #373737);
    }
    &__type {
      margin-top: 40px;
      display: flex;
      justify-content: space-between;
      &_par {
        margin-right: 15px;
        .title {
          @include fontStyle(Roboto, normal, 400, 24px, 29px, #373737);
        }
        .sub {
          @include fontStyle(Roboto, normal, 300, 16px, 19px, #373737);
        }
      }
    }
    &__btn {
      &__mobile {
        display: none;
      }
      button {
        width: 280px;
        height: 69px;
        background-color: #fff;
        a {
          color: #8948b1;
        }
        &:hover {
          a {
            text-decoration: underline;
          }
        }
      }
    }
  }
  &-right {
    img {
      width: 100%;
      min-width: 155px;
      &:first-child {
        padding-top: 60px;
      }
    }
  }
  &:hover {
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.35);
  }
  @include mobile() {
    margin: 30px 0;
    flex-wrap: wrap;
    border-radius: 3px;
    padding: 20px;
    &-left {
      &__title {
        font-size: 16px;
        line-height: 17px;
        margin-bottom: 5px;
      }
      &__sub {
        font-size: 14px;
        line-height: 14px;
      }
      &__type {
        margin-top: 10px;
        flex-wrap: wrap;
        &_par {
          width: 100%;
          .title {
            font-size: 14px;
            line-height: 16px;
            font-weight: 600;
          }
          .sub {
            font-size: 14px;
            line-height: 14px;
            margin-top: -14px;
          }
        }
      }
      &__btn {
        display: none;
        &__mobile {
          display: block;
          text-align: center;
          margin: 0 auto;
          margin-top: 10px;
          // margin-bottom: -12%;
          order: 3;
          border-radius: 3px;
          button {
            background-color: #fff;
            min-width: 200px;
            height: 34px;
            border-radius: 3px;
            font-size: 9px;
            line-height: 12px;
            a {
              color: #8948b1;
            }
          }
        }
      }
    }
    &-right {
      margin: 0 auto;
      text-align: center;
      width: 100%;
      img {
        min-width: 140px;
        width: 204px;
        margin-top: -5px;
        padding-top: 0px !important;
      }
    }
  }
  @include tablet() {
    margin-top: 30px;
    flex-wrap: wrap;
    border-radius: 3px;
    padding: 20px;
    &-left {
      width: 100%;
      &__title {
        font-size: 12px;
        line-height: 15px;
      }
      &__sub {
        font-size: 10px;
        line-height: 12px;
      }
      &__type {
        margin-top: 10px;
        flex-wrap: wrap;
        &_par {
          width: 100%;
          .title {
            font-size: 10px;
            line-height: 12px;
            font-weight: 600;
          }
          .sub {
            font-size: 10px;
            line-height: 12px;
            margin-top: -14px;
          }
        }
      }
      &__btn {
        display: none;
        &__mobile {
          display: block;
          text-align: center;
          margin: 0 auto;
          margin-top: 10px;
          margin-bottom: -13%;
          order: 3;
          border-radius: 3px;
          button {
            background-color: #fff;
            width: 134px;
            height: 28px;
            border-radius: 3px;
            font-size: 9px;
            line-height: 12px;
            a {
              color: #8948b1;
            }
          }
        }
      }
    }
    &-right {
      margin: 0 auto;
      text-align: center;
      width: 100%;
      img {
        min-width: 122px;
        width: 144px;
        margin-top: 10px;
        padding-top: 0px !important;
      }
    }
  }
  @include tablet-1024() {
    flex-wrap: wrap;
    &-left {
      &__title {
        font-size: 30px;
        line-height: 35px;
      }
      &__sub {
        padding-top: 20px;
        font-size: 12px;
        line-height: 16px;
      }
      &__btn {
        button {
          width: 240px;
          height: 50px;
          border-radius: 8px;
          font-size: 13px;
          line-height: 18px;
        }
      }
      &__type {
        .title {
          font-size: 15px;
          line-height: 22px;
          margin-bottom: 0;
        }
        .sub {
          font-size: 10px;
          line-height: 13px;
        }
      }
    }
    &-right {
      margin: 0 auto;
      img {
        min-width: 162px;
        width: 162px;
        margin-top: 30px;
      }
    }
  }
  @include desktop() {
    &-left {
      &__title {
        font-size: 28px;
        line-height: 33px;
        padding-bottom: 10px;
      }
      &__sub {
        font-size: 17px;
        line-height: 19px;
      }
      &__type {
        &_par {
          .title {
            font-size: 18px;
            line-height: 18px;
          }
          .sub {
            font-size: 13px;
            line-height: 14px;
          }
        }
      }
      &__btn {
        button {
          width: 200px;
          height: 50px;
          border-radius: 8px;
          font-size: 12px;
          line-height: 17px;
        }
      }
    }
  }
  @include desktop-max() {
    &-left {
      &__type {
        width: 100%;
        &_par {
          margin-right: 30px;
        }
      }
    }
  }
}
</style>
